import { companyActionTypes } from "./company.types";

const INITIAL_STATE = {
  company: null,
  companyValidated: false
};

const companyReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case companyActionTypes.SET_COMPANY:
      return {
        ...state,
        company: action.payload
      };
    case companyActionTypes.SET_COMPANY_VALIDATED:
      return {
        ...state,
        companyValidated: action.payload
      };
    default:
      return state;
  }
};

export default companyReducer;